var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "single-automation-container" }, [
    _c(
      "div",
      {
        staticClass: "d-flex flex-row mb-2",
        class: _vm.shared ? "justify-content-around" : "justify-content-end",
      },
      [
        _vm.shared
          ? _c(
              "div",
              { staticClass: "d-inline-flex align-items-center flex-row" },
              [
                _c(
                  "div",
                  { staticClass: "thumbnail-item" },
                  [
                    _c(
                      "profile-avatar",
                      _vm._b(
                        {
                          staticClass: "client-profile-owner-avatar mr-2",
                          attrs: { "avatar-options": { inline: false } },
                        },
                        "profile-avatar",
                        Object.assign({}, _vm.owner),
                        false
                      )
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", { staticClass: "tiny-f m-0" }, [
                  _c("span", { staticClass: "bold" }, [
                    _vm._v(
                      _vm._s(_vm.owner.givenName) +
                        " " +
                        _vm._s(_vm.owner.familyName) +
                        "\n          " +
                        _vm._s(
                          _vm.$t("automations.boardLevel.shareAutomation")
                        ) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(
                    "\n         - " +
                      _vm._s(_vm.$t("global.actions.createdOn")) +
                      "\n        " +
                      _vm._s(
                        _vm._f("formatDateHour")(_vm.automation.createdAt)
                      ) +
                      "\n      "
                  ),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "dropdown-menu" }, [
          _c(
            "a",
            {
              staticClass:
                "dropdown-item clickable edit-automation text-primary text-capitalize",
              on: { click: _vm.edit },
            },
            [_vm._v(_vm._s(_vm.$t("global.words.edit")))]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass:
                "dropdown-item clickable delete-automation btn-danger text-danger",
              on: { click: _vm.remove },
            },
            [_vm._v(_vm._s(_vm.$t("global.words.delete")))]
          ),
          _vm._v(" "),
          _vm.IS_USAGE_RESTRICTED
            ? _c(
                "a",
                {
                  staticClass: "dropdown-item clickable",
                  class: { disabled: _vm.disabledSwitch() },
                  on: {
                    click: function () {
                      return (_vm.isActive = !_vm.isActive)
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.isActive
                        ? _vm.$t("global.words.enabled")
                        : _vm.$t("global.words.disabled")
                    )
                  ),
                ]
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "flex-row justify-content-end align-items-start d-none d-xl-flex",
          },
          [
            _c(
              "plan-tooltip",
              {
                attrs: {
                  page: _vm.currentPagePlan,
                  disabled:
                    !_vm.disabledSwitch() || _vm.changingAutomationStatus,
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "pretty p-switch p-fill d-flex align-items-center justify-content-center mt-1 mr-0",
                    class: { disabled: _vm.disabledSwitch() },
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.isActive,
                          expression: "isActive",
                        },
                      ],
                      attrs: { id: _vm.labelValue, type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.isActive)
                          ? _vm._i(_vm.isActive, null) > -1
                          : _vm.isActive,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.isActive,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.isActive = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.isActive = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.isActive = $$c
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      { staticClass: "d-none", attrs: { for: _vm.labelValue } },
                      [_vm._v(_vm._s(_vm.$t("global.words.switch")))]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "state" }, [
                      _c(
                        "label",
                        {
                          staticClass: "mb-0 ml-1",
                          style: { marginTop: "1px" },
                        },
                        [_vm._v(_vm._s(_vm.$t("global.words.enabled")))]
                      ),
                    ]),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "column-divider-left ml-2 pl-2 d-flex flex-row",
                style: { marginTop: "1.25px" },
              },
              [
                _c(
                  "a",
                  {
                    staticClass:
                      "clickable edit-automation bold text-primary text-capitalize",
                    on: { click: _vm.edit },
                  },
                  [_vm._v(_vm._s(_vm.$t("global.words.edit")))]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "clickable ml-2 delete-automation",
                    on: { click: _vm.remove },
                  },
                  [_c("i", { staticClass: "fa fa-trash text-danger" })]
                ),
              ]
            ),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        class: _vm.automationWrapperClass,
        attrs: { id: "automation-wrapper" },
      },
      [
        _c("span", [_vm._v("... ")]),
        _vm._v(" "),
        _vm.automation["trigger-arguments"]
          ? _c(
              "div",
              _vm._l(
                _vm.trigger["trigger-arguments"],
                function (triggerArgument, index) {
                  return _c(
                    "span",
                    {
                      key:
                        "automation-" +
                        _vm.automation.id +
                        "-trigger-argument-" +
                        index,
                    },
                    [
                      _c("span", [_vm._v(_vm._s(triggerArgument.name) + " ")]),
                      _vm._v(" "),
                      _c("b", [
                        _vm._v(
                          _vm._s(
                            _vm.automation["trigger-arguments"][
                              triggerArgument.id
                            ].name
                          ) + ","
                        ),
                      ]),
                    ]
                  )
                }
              ),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            " " +
              _vm._s(_vm.$t("automations.boardLevel.performTheFollowingTask")) +
              " "
          ),
        ]),
        _vm._v(" "),
        _c("b", { staticClass: "text-primary" }, [
          _vm._v(" " + _vm._s(_vm.action.name)),
        ]),
        _vm._v(" "),
        _vm._l(_vm.actionArguments, function (actionArgument, index) {
          return [
            _c(
              "span",
              {
                key:
                  "automation-" +
                  _vm.automation.id +
                  "-action-argument-name-" +
                  index,
              },
              [_vm._v(" " + _vm._s(actionArgument.name) + " ")]
            ),
            _vm._v(" "),
            _c(
              _vm.typeToComponent(actionArgument.type, _vm.action),
              _vm._b(
                {
                  key:
                    "automation-" +
                    _vm.automation.id +
                    "-action-argument-" +
                    index,
                  tag: "component",
                  attrs: {
                    title: _vm.automation["action-arguments"].title,
                    "read-only": "",
                  },
                },
                "component",
                _vm.typeToProps(actionArgument),
                false
              )
            ),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass:
          "d-flex justify-content-end grey-text text-darken-4 clickable option-dropdown d-xl-none",
        attrs: { "data-toggle": "dropdown" },
      },
      [_c("i", { staticClass: "material-icons" }, [_vm._v("more_vert")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }